export default "__VITE_ASSET__6370a97d__"